module.exports = __webpack_public_path__ + "static/img/product6.c947c05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product6.png
// module id = hYg7
// module chunks = 1